/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarHistogram: {
  name: 'bar-histogram';
  data: string;
} = {
  name: 'bar-histogram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1ZM6 8a1 1 0 0 0-2 0v2a1 1 0 1 0 2 0V8Zm13 3a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1ZM5 13a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm15-7a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V6Zm-8 11a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Zm1-7a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4Z" fill="currentColor"/></svg>`,
};
